import cx from 'clsx';
import displayStyles from 'styles/global/display.module.scss';
import messages from 'messages/base-pl';
import React, { FunctionComponent } from 'react';
import styles from './Hamburger.module.scss';
import utilityStyles from 'styles/global/utility.module.scss';
import { Cross as CrossIcon, Hamburger as HamburgerIcon } from 'assets/icons';
import { Icon } from 'components/elements';
import { useIntl } from 'react-intl';

interface OwnProps {
  opened: boolean;
}

type HamburgerProps = JSX.IntrinsicElements['button'] & OwnProps;

const Hamburger: FunctionComponent<HamburgerProps> = props => {
  const { formatMessage } = useIntl();
  const { className, opened, ...rest } = props;

  const hamburgerClassName = cx({
    [utilityStyles.resetInput]: true,
    [displayStyles.centerBoth]: true,
    [styles.hamburger]: true,
    [styles.opened]: opened,
    ...(className && { [className]: true }),
  });

  return (
    <button className={hamburgerClassName} {...rest}>
      <Icon size={20} className={styles.open} icon={HamburgerIcon} />
      <Icon size={20} className={styles.close} icon={CrossIcon} />
      {!opened && <span className={utilityStyles.visuallyHidden}>{formatMessage(messages.header_menu)}</span>}
      {opened && <span className={utilityStyles.visuallyHidden}>{formatMessage(messages.header_menu_closed)}</span>}
    </button>
  );
};

export default Hamburger;
